/* globals fetch, axios */

/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: dropdown
 | -------------------------------------------------------------
 |
 |  Functionality for elements that contain a dropdown menu.
 |
*/

/**
 * 1. take onchange event for input values
 * 2. place them in the calllut
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const addressFields = document.querySelectorAll('[data-pro6pp]')

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

const getErrorMessage = (errors) => {
  console.log(errors)
  if (errors.p !== undefined) {
    return errors.p
  }
  if (errors.n !== undefined) {
    return errors.n
  }
  if (errors.e !== undefined) {
    return errors.e
  }
}

const getFullAddress = (node, postcode, number, extension) => {
  if (undefined !== axios) {
    axios.get('/pro6pp/complete?p=' + postcode + '&n=' + number + '&e=' + extension, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data.street) {
          node.innerHTML = `${response.data.street} ${response.data.streetnumber}  ${response.data.extension}<br />${response.data.nl_sixpp} ${response.data.city}`
        }
        if (response.data.error) {
          node.innerHTML = response.data.error
        }
      })
      .catch((err) => {
        node.innerHTML = getErrorMessage(err.response.data.errors)
      })
  } else {
    fetch('/pro6pp/complete?p=' + postcode + '&n=' + number + '&e=' + extension, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        return response.json()
      })
      .then((response) => {
        if (response.status === 'ok') {
          node.innerHTML = `${response.data.street} ${response.data.full_number}  ${response.data.extension}<br />${response.data.postcode} ${response.data.city}`
        }
        if (response.status === 'error') {
          node.textContent = response.data
        }
      })
  }
}

const autocompleteAddress = (event) => {
  const addressCurrent = event.target.closest('[data-pro6pp]')
  const calloutInner = addressCurrent.querySelector('.callout__description')
  const addressInputs = addressCurrent.querySelectorAll('input')
  const addressPostcode = addressInputs[0].value
  const addressNumber = addressInputs[1].value
  const addressExtension = addressInputs[2].value

  getFullAddress(calloutInner, addressPostcode, addressNumber, addressExtension)
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

if (addressFields) {
  // maybe use a foreach?
  for (let i = 0; i < addressFields.length; i++) {
    addressFields[i].addEventListener('change', autocompleteAddress)
  }
}
